import { IconSend } from '@tabler/icons-react';
import { Button } from '../../../components/common/Button';
import { Card } from '../../../components/common/Card';
import classes from '../css/QuestionNavigation.module.css';

interface Props {
  /** Question ids in display order (same order as the main question list). */
  questionIds: number[];
  currentIndex: number;
  /** Question ids that count as answered (e.g. saved on server for regular exams). */
  answeredIds: Set<number>;
  flaggedIds: Set<number>;
  /** Question ids that are saved locally but not yet synced to the server. */
  pendingSyncIds: Set<number>;
  onSelectQuestion: (index: number) => void;
  onSubmit: () => void;
}

export function QuestionNavigation({
  questionIds,
  currentIndex,
  answeredIds,
  flaggedIds,
  pendingSyncIds,
  onSelectQuestion,
  onSubmit,
}: Props) {
  const totalQuestions = questionIds.length;

  return (
    <Card className={classes.card} shadow="sm" radius="md">
      <div className={classes.header}>Question Navigation</div>
      <div className={classes.grid}>
        {Array.from({ length: totalQuestions }, (_, i) => {
          const qid = questionIds[i];
          const isActive = currentIndex === i;
          const isFlagged = flaggedIds.has(qid);
          const isAnswered = answeredIds.has(qid);
          const isPendingSync = pendingSyncIds.has(qid);
          let btnClass = classes.btn;
          if (isActive) btnClass += ` ${classes.btnActive}`;
          else if (isFlagged) btnClass += ` ${classes.btnFlagged}`;
          else if (isPendingSync) btnClass += ` ${classes.btnPendingSync}`;
          else if (isAnswered) btnClass += ` ${classes.btnAnswered}`;
          else btnClass += ` ${classes.btnUnanswered}`;
          return (
            <Button
              key={i}
              className={btnClass}
              onClick={() => onSelectQuestion(i)}
              aria-label={`Question ${i + 1}`}
            >
              {i + 1}
            </Button>
          );
        })}
      </div>
      <div className={classes.legend}>
        <div className={classes.legendItem}>
          <span className={`${classes.legendDot} ${classes.legendAnswered}`} />
          Answered
        </div>
        <div className={classes.legendItem}>
          <span className={`${classes.legendDot} ${classes.legendUnanswered}`} />
          Unanswered
        </div>
        <div className={classes.legendItem}>
          <span className={`${classes.legendDot} ${classes.legendPendingSync}`} />
          Pending Sync (Offline)
        </div>
        <div className={classes.legendItem}>
          <span className={`${classes.legendDot} ${classes.legendFlagged}`} />
          Flagged for Review
        </div>
      </div>
      <Button className={classes.submitExamBtn} onClick={onSubmit}>
        <IconSend size={18} />
        Submit Exam
      </Button>
    </Card>
  );
}
